import { Box, ProgressStepper, Tag, Text } from '@zillow/constellation-10';

import { LISTING_SUMMARY_DISPLAY_STATUS } from '../../constants/ListingSummaryConstants';
import { PROGRESS_STEP_KEYS, STEP_DELIMITER } from '../CreateListingPage/constants/stepKeys';
import { PROGRESS_GROUPS, STEP_TO_PROGRESS_KEY } from '../CreateListingPage/constants/stepRegistry';

import { FlowType } from '../CreateListingPage/types';

type Props = {
  status: keyof typeof LISTING_SUMMARY_DISPLAY_STATUS;
  step: string;
};

// API stores steps as lowercase (e.g. 'pet_policy_and_pet_fee'); STEP_TO_PROGRESS_KEY keys are
// UPPER_SNAKE_CASE. Split on '::' strips the relisting suffix ('review::relisting' → 'REVIEW').
const normalizeStep = (step: string): string => step.toUpperCase().split(STEP_DELIMITER)[0];

const ProgressStepperSummary = ({ status, step }: Props) => {
  const progressStepKey = STEP_TO_PROGRESS_KEY[normalizeStep(step)] ?? PROGRESS_STEP_KEYS.PROPERTY_INFO;

  const groups = PROGRESS_GROUPS[FlowType.STANDARD];
  const activeStepIndex = groups.findIndex((g) => g.key === progressStepKey);

  const steps = groups.map((_g, index) => ({
    label: '',
    ...(index < activeStepIndex && { tone: 'complete' }),
  }));

  const statusTag = (status as string) === LISTING_SUMMARY_DISPLAY_STATUS.PUBLISHING ? 'Complete' : 'Incomplete';

  return (
    <Box data-testid="ProgressStepperSummary" css={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        data-testid="PSS-HeaderContainer"
        css={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingBottom: '200',
        }}
      >
        <Text textStyle="body-bold">Listing setup</Text>
        <Tag tone="gray">{statusTag}</Tag>
      </Box>

      <Box data-testid="ProgressStepperContainer">
        <ProgressStepper
          activeStepIndex={activeStepIndex}
          steps={steps}
          labelAppearance="none"
          aria-label="Listing setup progress"
        />
      </Box>
    </Box>
  );
};

export default ProgressStepperSummary;
